/** Predefined values vs. a continuous numeric Range — determines whether the Values table or Min/Max fields apply. */
export const ALLOWED_INPUTS = {
  PREDEFINED: 'PREDEFINED',
  RANGE: 'RANGE',
} as const;

export type AllowedInputsValue = (typeof ALLOWED_INPUTS)[keyof typeof ALLOWED_INPUTS];
